import { useQuery } from '@tanstack/react-query';
import { fetcher } from '~/shared/utils/request/utils/fetcher';
import {
    DropPointDto,
    DropPointSearchQuery,
} from '~/lib/data-contract/auto-generated/droppoints-model';

type Props = DropPointSearchQuery & {
    disabled: boolean;
    zipCode: string;
};

export const useDroppoints = ({ select, zipCode, ...params }: Props) => {
    return useQuery<DropPointDto[], Error>({
        queryKey: ['/api/checkout/droppoints', params.carrier?.id, zipCode],
        queryFn: fetcher<DropPointDto[]>('/api/checkout/droppoints', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
        }),
        select,
        enabled: !!params.carrier?.id && !params.disabled,
    });
};
